module.exports = __webpack_public_path__ + "static/img/img4.a63635f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/cooperation_case/img4.png
// module id = sOPn
// module chunks = 0